import { render, staticRenderFns } from "./MarketplaceFooter.vue?vue&type=template&id=eeca30e8"
import script from "./MarketplaceFooter.vue?vue&type=script&lang=js"
export * from "./MarketplaceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports